import React from 'react'
import "./Footer.css"

const Footer = () => {
  return (
    <>
    <footer>
        {/* <div className="footer-heading">
            BigWing
        </div> */}
        <div className="link-wrapper">
            <div className="useful">
                <div className="useful-heading">
                    Useful Links
                <ul className='useful-list'>
                            <li className='useful-opt'>About Us</li>
                            <li className='useful-opt'>About services</li>
                            <li className='useful-opt'>About Departments</li>
                            <li className='useful-opt'>Services</li>
                            <li className='useful-opt'>Contact Us</li>
                    </ul>
                </div>
            </div>
            <div className="service">
             
                <div className="useful-heading">
                Services
                <ul className='useful-list'>
                            <li className='useful-opt'>About Us</li>
                            <li className='useful-opt'>About services</li>
                            <li className='useful-opt'>About Departments</li>
                            <li className='useful-opt'>Services</li>
                            <li className='useful-opt'>Contact Us</li>
                    </ul>
                </div>
            </div>
            <div className="contact">
               
                <div className="useful-heading">
                Contact us
                    <ul className='useful-list'>
                            <li className='useful-opt'>About Us</li>
                            <li className='useful-opt'>About services</li>
                            <li className='useful-opt'>About Departments</li>
                            <li className='useful-opt'>Services</li>
                            <li className='useful-opt'>Contact Us</li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
    </>
  )
}

export default Footer